import React, { useEffect } from 'react';
import './About.css';
import { initWOW } from '../../utils/animations';

const About = () => {
  useEffect(() => {
    initWOW();
  }, []);

  const leadership = [
    {
      name: 'Vadym Shevchuk',
      role: 'CEO',
      linkedin: 'https://linkedin.com/in/vadymshevchuk',
      image: '/images/Vadym.jpg'
    },
    {
      name: 'Kamila Talashchuk',
      role: 'Art Director',
      linkedin: 'https://linkedin.com/in/kamilatalashchuk',
      image: '/images/Kamila.jpg'
    },
    {
      name: 'Dzmitry Bohdan',
      role: 'Delivery Manager',
      linkedin: 'https://linkedin.com/in/dzmitrybohdan',
      image: '/images/Dzmitry.jpg'
    },
    {
      name: 'Roman Krushanovsky',
      role: 'Tech Lead',
      linkedin: 'https://linkedin.com/in/romankrushanovsky',
      image: '/images/Roman.jpg'
    },
    {
      name: 'Alex Chan',
      role: '3D Lead',
      linkedin: 'https://linkedin.com/in/alexchan',
      image: '/images/Alex.jpg'
    }
  ];

  return (
    <div className="about-page">
      {/* 1. INTRO SECTION */}
      <div id="about-intro" className="container-fluid fh5co-content-box">
        <div className="container-fluid px-5">
          <div className="row align-items-center about-section-row">
            <div className="col-lg-4">
              <div className="about-intro-text">
                <h2 className="wow bounceInRight about-section-heading">
                  About Pixward Studios
                </h2>
                <p className="wow bounceInLeft text-white mb-4 about-section-text">
                  Pixward Studios is a team of 15 creators, engineers, and artists who've spent almost eight years building virtual, immersive worlds.
                </p>
                <p className="wow bounceInLeft text-white mb-4 about-section-text">
                  We design VR training, games, and real-time environments that help people learn faster, understand deeper, and experience ideas in a way traditional formats simply can't match.
                </p>
                <h3 className="wow bounceInLeft about-section-heading" style={{fontSize: '2rem', marginTop: '2rem', marginBottom: '1.5rem'}}>
                  Our Vision
                </h3>
                <p className="wow bounceInLeft text-white mb-4 about-section-text">
                  We believe immersive worlds can teach, inspire, and solve real problems.
                </p>
                <p className="wow bounceInLeft text-white mb-4 about-section-text">
                  Our goal is to create experiences that feel meaningful — whether it's training someone for a real-world task or bringing a creative vision to life.
                </p>
                <p className="wow bounceInLeft text-white mb-0 about-section-text">
                  And we're here to help you build something that truly resonates.
                </p>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="about-intro-visual wow bounceInLeft">
                <img 
                  src="/images/Team_Photo_1.jpg" 
                  alt="Pixward Studios Team" 
                  className="about-visual-image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 2. LOGOS MARQUEE */}
      <div className="logos-marquee-wrapper">
        <div className="logos-marquee">
          {/* Duplicate logos for seamless loop */}
          {[...Array(3)].map((_, setIndex) => (
            <div key={`set-${setIndex}`} className="logos-marquee-set">
              {[
                '3ds-Max-Logo--Streamline-Logos.svg',
                'adobe-photoshop.svg',
                'Octicons-mark-github.svg',
                'substance-painter.svg',
                'Unity_Technologies-Logo.wine.svg',
                'unreal-engine-svgrepo-com.svg',
                'Zbrush_Logo.svg'
              ].map((logo, index, array) => (
                <div 
                  key={`logo-${setIndex}-${index}`} 
                  className="logo-item"
                  style={index === array.length - 1 ? { marginRight: '4rem' } : {}}
                >
                  <img 
                    src={`/images/${logo}`} 
                    alt="Partner logo" 
                    className="logo-image"
                    style={logo === 'Unity_Technologies-Logo.wine.svg' ? { transform: 'scale(1.3)' } : {}}
                  />
              </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* 3. LEADERSHIP */}
      <div id="about-leadership" className="container-fluid fh5co-content-box">
        <div className="container-fluid px-5">
          <div className="about-leadership-content">
            <div className="row">
              <div className="col-12">
                <div className="quote-box2 wow bounceInDown" data-wow-delay=".15s">
                  <h2 style={{color: '#ff6600'}}>LEADERSHIP</h2>
                </div>
              </div>
            </div>
            <div className="row about-leadership-cards">
              {leadership.map((person, index) => (
                <div key={index} className="col about-leadership-card-col">
                  <div className={`leadership-card wow ${index === 0 ? 'bounceInLeft' : index === 1 ? 'bounceInUp' : index === 2 ? 'bounceInUp' : index === 3 ? 'bounceInUp' : 'bounceInRight'}`} 
                       data-wow-delay={`${0.1 + index * 0.05}s`}>
                    <div 
                      className="leadership-photo-placeholder"
                      style={{
                        backgroundImage: person.image ? `url('${person.image}')` : 'none',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                      }}
                    ></div>
                    <div className="leadership-info">
                      <h4 className="text-white mb-2">{person.name}</h4>
                      <p className="text-white mb-3 leadership-role">{person.role}</p>
                      <a href={person.linkedin} target="_blank" rel="noopener noreferrer" className="text-white leadership-link">
                        LinkedIn →
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
